import { AlertTriangle, ChevronRight } from 'lucide-react';

import type { CatalogAlertBannerProps } from '~/features/catalog-operations/types/catalog-operations.types';

/**
 * Warning banner shown at the top of Catalog Operations when products need attention.
 * Displays a total count and a dot-separated breakdown of attention categories.
 */
export function CatalogAlertBanner({ totalCount, categories, onViewAll }: CatalogAlertBannerProps) {
  const breakdown = categories.map((c) => `${String(c.count)} ${c.description}`).join(' · ');

  return (
    <div
      data-testid="catalog-ops-attention-banner"
      className="flex items-center justify-between rounded-lg border border-red-200 bg-[#FDECEA] px-4 py-3"
    >
      <div className="flex items-center gap-3">
        <AlertTriangle className="h-4 w-4 shrink-0 text-orange-500" aria-hidden="true" />
        <p className="text-sm">
          <span
            data-testid="catalog-ops-attention-banner-count"
            className="font-semibold text-orange-700"
          >
            {totalCount} Products Need Attention
          </span>
          <span
            data-testid="catalog-ops-attention-banner-breakdown"
            className="text-stage-text ml-2"
          >
            {breakdown}
          </span>
        </p>
      </div>

      <button
        type="button"
        data-testid="catalog-ops-attention-banner-view-all-button"
        onClick={onViewAll}
        aria-label={`View all ${String(totalCount)} products needing attention`}
        className="text-accent-main flex shrink-0 cursor-pointer items-center gap-0.5 text-sm font-medium hover:underline"
      >
        View All
        <ChevronRight className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
